import React from 'react';
import { Text } from '@heartinternet/hi-ui';
import type { CreditBatch } from '../types';
import { CreditPricingCard } from './CreditPricingCard';

interface CreditPricingSectionProps {
  heading: string;
  /** Anchor id for sidebar deep-links (e.g. purchase-ti). */
  headingId?: string;
  description: React.ReactNode;
  products: CreditBatch[];
  cgiUrl: string;
  paypalAllowed?: boolean;
}

export const CreditPricingSection: React.FC<CreditPricingSectionProps> = ({
  heading,
  headingId,
  description,
  products,
  cgiUrl,
  paypalAllowed,
}) => (
  <section className="hi-ui-order-domain-credits-page__section">
    <Text variant="heading-2" id={headingId}>
      {heading}
    </Text>
    <Text variant="body">{description}</Text>
    <div className="hi-ui-order-domain-credits-page__card-grid">
      {products.map((batch) => (
        <CreditPricingCard
          key={batch.id}
          batch={batch}
          cgiUrl={cgiUrl}
          paypalAllowed={paypalAllowed}
        />
      ))}
    </div>
  </section>
);
